<template>
  <div class="visit-page pb-3">
    <div class="container">
      <!-- Заголовок и описание из content -->
      <div v-html="getTitleHtml()"></div>
      <div v-html="getDescriptionHtml()"></div>

      <!-- Состояние загрузки -->
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Загрузка...</span>
        </div>
      </div>

      <!-- Состояние ошибки -->
      <div v-else-if="error" class="alert alert-danger" role="alert">
        Не удалось загрузить данные. Пожалуйста, попробуйте позже.
      </div>

      <!-- Карточки поездок -->
      <div v-else class="visit__items-container">
        <div
            class="visit__item"
            v-for="item in items"
            :key="item.id"
        >
          <div class="visit__item-img">
            <img
                :src="getImageSrc(item.code)"
                alt=""
            />
          </div>
          <div class="visit__item-content">
            <div class="visit__item-content-title">
              {{ item.title }}
            </div>
            <a
                class="visit__item-content-link"
                :href="`/visits/${item.code}`"
            >
              подробнее о поездке
              <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.75 2.79166L6.66667 5.99999L3.75 9.20833" stroke="#D2233C" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.75 2.79166L9.66667 5.99999L6.75 9.20833" stroke="#D2233C" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
<!--            <div class="visit__item-button-container">-->
<!--              <a-->
<!--                  class="visit__item-button"-->
<!--                  href="/"-->
<!--                  @click.prevent="goToRequestForm(item.code)"-->
<!--              >-->
<!--                ОФОРМИТЬ ЗАЯВКУ-->
<!--              </a>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '@/lib/axios';

export default {
  name: "Visit",
  data: () => ({
    type: 4,
    page: {},
    items: [],
    loading: false,
    error: false,
  }),
  methods: {
    async fetchPageData() {
      try {
        const response = await get("static-page/" + this.type);
        this.page = response.data.data;
      } catch (error) {
        console.error('Ошибка при загрузке данных страницы:', error);
        // Можно оставить page пустым или показать заглушку
      }
    },

    async fetchVisitItems() {
      this.loading = true;
      this.error = false;

      try {
        const response = await get("visit/list");
        this.items = response.data.items || [];
      } catch (error) {
        console.error('Ошибка при загрузке списка поездок:', error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    getTitleHtml() {
      const match = this.page.content?.match(/<div class="visit__title">[\s\S]*?<\/div>/);
      return match ? match[0] : '';
    },

    getDescriptionHtml() {
      const match = this.page.content?.match(/<div class="visit__description">[\s\S]*?<\/div>/);
      return match ? match[0] : '';
    },

    getImageSrc(code) {
      const images = {
        perm: '/img/visit/perm.png',
        torzhok: '/img/visit/torzhok.png',
        tyumen: '/img/visit/tyumen.png',
        kazakhstan: '/img/visit/kz.png',
      };
      return images[code] || '/img/visit/default.png';
    },

    goToRequestForm(code) {
      this.$router.push({
        name: 'VisitRequestForm',
        params: { slug: code }
      });
    }
  },

  async mounted() {
    // Запускаем оба запроса параллельно для ускорения загрузки
    await Promise.all([
      this.fetchPageData(),
      this.fetchVisitItems()
    ]);
  },

  metaInfo() {
    return {
      title: `Поездки - ЛУКМАРКЕТ`,
    };
  },
};
</script>

<style lang="scss">
.visit-page {
  margin-top: 40px;

  .page-title {
    color: #212529;
    padding-top: 40px;
  }

  .brand-color {
    color: #d2233c;
  }

  .font-size-1rem {
    font-size: 1rem;
  }

  .white-space-nowrap {
    white-space: nowrap;
  }

  .g-horisontal-spacer {
    min-height: 30px;
  }

  .g-resize {
    display: block;
    width: 100%;
    height: auto !important;
  }

  .img-bottom-spacer {
    margin-bottom: 20px;
  }

  .default-text-decoration {
    font: 21px/30px Futuris;
    color: #4a4a4a;
    text-align: justify;
  }

  .default-text-decoration strong {
    font: 21px/30px Futuris;
  }

  .default-text-decoration p {
    padding: 10px 0 20px;
  }

  .g-horisontal-spacer {
    min-height: 30px;
  }

  .default-text-decoration--ileft-right {
    display: block;
  }

  .default-text-decoration--out-pad {
    display: block;
  }

  .default-text-decoration--two-col {
    column-count: 2;
    column-gap: 30px;
    text-align: left;
  }

  .g-horisontal-line {
    display: block;
    border-bottom: solid #dfe1e3 1px;
    margin-top: 56px;
    margin-bottom: 40px;
  }

  .inner-section-title__link,
  .inner-section-title {
    display: block;
    text-transform: uppercase;
    color: #212529;
    font: 700 16px/24px Futuris;
    text-decoration: none !important;
  }

  .perm-section-title {
    margin-bottom: 2rem;
  }

  .default-link {
    display: inline-block;
    color: #d2233c;
    text-decoration: none !important;
  }

  .container-center {
    display: block;
    text-align: center;
  }

  .request-form-btn {
    text-align: center;
    display: inline-block;
    background: #d2233c;
    border-radius: 4px;
    color: #fff;
    text-transform: uppercase;
    font: 700 16px/24px Futuris;
    margin-top: 20px;
    padding: 10px;
    text-decoration: none;

    @media (max-width: 992px) {
      margin: 20px 0 40px 0;
    }

    @media (min-width: 1100px) {
      min-width: 275px;
    }
  }

  .request-form-btn:hover {
    color: #fff;
    text-decoration: none;
  }

  @media (max-width: 768px) {
    .default-text-decoration--two-col {
      column-count: 1;
      column-gap: 0;
    }
  }

}
</style>
